import {Logger} from '../Utils/Logger';
import {ErrorFunction} from '../Utils/CommonTypes';
import {PreloaderResourceLoader} from './Types/PreloaderResourceLoader';
import {PreloaderResourceItem} from './Types/PreloaderResourceItem';

export class EmptyResourceLoader extends PreloaderResourceLoader {
    constructor(audio: boolean) {
        super(audio);
    }

    beforeResourcesLoad(): void {}

    loadAllGroupsCompleted(): void {}

    loadResources(resources: Array<PreloaderResourceItem>, resolveCallback: ErrorFunction): void {
        if (DEBUG) {
            Logger.errorGroup('EmptyResourceLoader', `EmptyResourceLoader is not supposed to load any resources!`);
        }

        resolveCallback(null);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Preloader/EmptyResourceLoader.ts
 **/